import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const stats = [
  { value: 12, suffix: '+', label: 'Anos de experiência', icon: 'ri-calendar-check-line' },
  { value: 5000, suffix: '+', label: 'Viajantes realizados', icon: 'ri-user-heart-line' },
  { value: 50, suffix: '+', label: 'Destinos no mundo', icon: 'ri-global-line' },
  { value: 98, suffix: '%', label: 'Clientes satisfeitos', icon: 'ri-star-line' },
];

export default function StatsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [counts, setCounts] = useState(stats.map(() => 0));
  const hasAnimated = useRef(false);

  useEffect(() => {
    const ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: sectionRef.current,
        start: 'top 75%',
        onEnter: () => {
          if (hasAnimated.current) return;
          hasAnimated.current = true;

          stats.forEach((stat, index) => {
            const proxy = { count: 0 };
            gsap.to(proxy, {
              count: stat.value,
              duration: 2.5,
              ease: 'power2.out',
              delay: index * 0.15,
              onUpdate: () => {
                setCounts((prev) => {
                  const next = [...prev];
                  next[index] = Math.round(proxy.count);
                  return next;
                });
              },
            });
          });

          const cards = sectionRef.current?.querySelectorAll('.stat-card');
          if (cards) {
            gsap.fromTo(
              cards,
              { y: 30, opacity: 0 },
              {
                y: 0,
                opacity: 1,
                duration: 0.7,
                stagger: 0.12,
                ease: 'power3.out',
              }
            );
          }
        },
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full py-20 md:py-24 px-6 md:px-10 lg:px-16 bg-primary-500">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <div key={i} className="stat-card text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl mb-4 mx-auto">
                <i className={`${stat.icon} text-white text-2xl`}></i>
              </div>
              <div className="font-heading text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-2">
                {counts[i]}{stat.suffix}
              </div>
              <p className="text-white/70 text-sm font-light tracking-wide">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}